import script from "./DocsSort.mobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocsSort.mobile.vue?vue&type=script&setup=true&lang=ts"

import "./DocsSort.mobile.vue?vue&type=style&index=0&id=5f69b685&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f69b685"]])

export default __exports__